import type { FinancePartnerRow } from "../store/oneButtonStore";

const OPP_PRODUCT_ORDER = ["Solar","Roof","Battery","Solar + Roof","Battery + Roof","Solar + Battery","RR","RRR",];

export function primarySavedFinanceFromOpportunity(opportunityDetails: any): { partner: string; method: string } | null {
    const raw = opportunityDetails?.OpportunityProduct ?? opportunityDetails?.opportunityProduct ?? [];
    const arr = Array.isArray(raw) ? raw : [];
    const active = arr.filter((p: any) => p.ActiveFlag !== false && p.activeFlag !== false);

    if (!active.length) return null;

    active.sort((a: any, b: any) => {
        const na = String(a.Product_Type_Name ?? a.product_Type_Name ?? "");
        const nb = String(b.Product_Type_Name ?? b.product_Type_Name ?? "");
        const ia = OPP_PRODUCT_ORDER.indexOf(na);
        const ib = OPP_PRODUCT_ORDER.indexOf(nb);
        return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
    });

    const p = active[0];
    const partner = String(p.Finance_Partner_Display_Name ??p.FinancePartnerDisplayName ??p.Finance_Partner ??"").trim();
    const method = String(p.Finance_Method_Name ?? p.FinanceMethod ?? "").trim();

    if (!partner || /select finance/i.test(partner)) return null;
    return { partner, method: method || "—" };
}

/** Active rows: treat missing ActiveFlag as active (same as `primarySavedFinanceFromOpportunity`). */
function opportunityProductActiveRows(opportunityDetails: any | null | undefined): any[] {
    const raw = opportunityDetails?.OpportunityProduct ?? opportunityDetails?.opportunityProduct ?? [];
    const arr = Array.isArray(raw) ? raw : [];
    return arr.filter((p: any) => p.ActiveFlag !== false && p.activeFlag !== false);
}

function productTypeName(p: any): string {
    return String(p?.Product_Type_Name ?? p?.product_Type_Name ?? "").trim();
}

/** Active opportunity product type names (e.g. Solar, Roof) for Pricing API `products`. */
export function activeOpportunityProductTypeNames(opportunityDetails: any | null | undefined): string[] {
    return opportunityProductActiveRows(opportunityDetails).map(productTypeName).filter(Boolean);
}

/** True when Pricing API payload `products` includes a solar product type. */
export function pricingPayloadRequiresSolarMetrics(payload: { products?: unknown }): boolean {
    const products = payload?.products;
    if (!Array.isArray(products) || products.length === 0) return false;
    return products.some((p) => {
        const lower = String(p).toLowerCase().replace(/\s+/g, "");
        return lower === "solar" || lower === "s" || lower.startsWith("solar");
    });
}

/**
 * True when every active `OpportunityProduct` row is Roof (no Solar / Battery / etc. on the opportunity).
 * Used to hide or disable utility editing for roof-only opportunities.
 */
export function isOpportunityActiveProductsRoofOnly(opportunityDetails: any | null | undefined): boolean {
    const active = opportunityProductActiveRows(opportunityDetails);
    if (!active.length) return false;
    return active.every((p) => productTypeName(p) === "Roof");
}

export function getFinanceSummaryDisplay(opportunityDetails: any | null,selectedFinanceCells: Set<string>,financingGrid: FinancePartnerRow[]): { 
    partner: string; method: string } | null {
    const saved = primarySavedFinanceFromOpportunity(opportunityDetails);
    if (saved) return saved;

    const key = Array.from(selectedFinanceCells)[0];
    if (!key) return null;

    const [partner, product] = key.split("::");
    const row = financingGrid.find((r) => r.partner === partner);
    const cell = row?.prices[product];
    const method = (cell?.financeMethod || "").trim() || "—";

    return { partner, method };
}
